<div class="d-flex flex-row justify-content-between align-items-center mt-3">
    <div class="form-inline">
        <span class="badge badge-warning">
            <span class="material-icons">
                work
            </span>
        </span>
        <h4 class="mt-2">Puestos de trabajo</h4>
    </div>
    <div class="btn-group" role="group">
        <button type="button" class="btn btn-info" (click)="addJob()">
            <span class="material-icons">
                people
            </span>
            <span>Agregar nuevo puesto</span>
        </button>
    </div>
</div>
<div class="row match-height">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title mb-0">Puestos</h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="media pt-0 pb-2" *ngFor="let job of jobs">
                        <div class="mr-3 avatar rounded">
                            <span class="badge bg-light-primary">
                                <span class="material-icons">
                                    work
                                </span>
                            </span>
                        </div>
                        <div class="media-body">
                            <h4 class="font-medium-1 mb-0">{{job.name}}</h4>
                            <p class="grey font-small-3 m-0">{{job.supervisorName}}</p>
                            <p class="grey font-small-3 m-0">{{job.auditorName}}</p>
                        </div>
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="selectJob(job)" ngbTooltip="Ver puesto">
                                <i class="ft-eye"></i>
                            </button>
                            <button type="button" class="btn btn-success" (click)="downloadFile(job.url)"
                                ngbTooltip="Descargar instructivo del puesto">
                                <i class="ft-download"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="selectedJob && selectedJob.id">
        <div class="card">
            <!--Procedures-->
            <div class="card-header d-flex justify-content-between">
                <h4 class="card-title mb-0">Procedimientos</h4>
                <button type="button" class="btn btn-success" ngbTooltip="Agregar procedimiento"
                    (click)="createProcedure()">
                    <span class="material-icons">
                        add
                    </span>
                </button>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="media pt-0 pb-2" *ngFor="let procedure of procedures">
                        <div class="mr-3 avatar rounded">
                            <span class="badge bg-light-info">
                                <span class="material-icons">
                                    <span class="material-icons">
                                        report
                                    </span>
                                </span>
                            </span>
                        </div>
                        <div class="media-body">
                            <h4 class="font-medium-1 mb-0">{{procedure.name}}</h4>
                            <p class="grey font-small-3 m-0">{{procedure.description}}</p>
                        </div>
                        <div class="btn-group">
                            <button type="button" class="btn btn-success" ngbTooltip="Descargar trouble-shooting"
                                (click)="downloadFile(procedure.url)">
                                <i class="ft-download"></i>
                            </button>
                            <button type="button" class="btn btn-danger" ngbTooltip="Borrar procedimiento">
                                <i class="ft-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!--Check points-->
            <div class="card-header d-flex justify-content-between">
                <h4 class="card-title mb-0">Puntos de control</h4>
                <button type="button" class="btn btn-success" ngbTooltip="Agregar punto de control"
                    (click)="createCheckPoint()">
                    <span class="material-icons">
                        add
                    </span>
                </button>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="media pt-0 pb-2" *ngFor="let checkPoint of checkPoints">
                        <div class="mr-3 avatar rounded">
                            <span class="badge bg-light-danger">
                                {{checkPoint.priority}}
                            </span>
                        </div>
                        <div class="media-body">
                            <h4 class="font-medium-1 mb-0">{{checkPoint.checkPoint}}</h4>
                            <p class="grey font-small-3 m-0" *ngIf="checkPoint.period === 1">Diario</p>
                            <p class="grey font-small-3 m-0" *ngIf="checkPoint.period === 7">Semanal</p>
                            <p class="grey font-small-3 m-0" *ngIf="checkPoint.period === 15">Quincenal</p>
                            <p class="grey font-small-3 m-0" *ngIf="checkPoint.period === 30">Mensual</p>
                        </div>
                        <div class="btn-group">
                            <button type="button" class="btn btn-success" ngbTooltip="Descargar trouble-shooting"
                                (click)="downloadFile(checkPoint.url)">
                                <i class="ft-download"></i>
                            </button>
                            <button type="button" class="btn btn-danger" ngbTooltip="Borrar punto de control">
                                <i class="ft-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="selectedJob && selectedJob.id">
        <div class="card">
            <!--Councils-->
            <div class="card-header d-flex justify-content-between">
                <h4 class="card-title mb-0">Juntas</h4>
                <button type="button" class="btn btn-success" ngbTooltip="Agregar Junta" (click)="createCouncil()">
                    <span class="material-icons">
                        add
                    </span>
                </button>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="media pt-0 pb-2" *ngFor="let council of councils">
                        <div class="mr-3 avatar rounded">
                            <span class="badge bg-light-danger">
                                {{council.frecuence}}
                            </span>
                        </div>
                        <div class="media-body">
                            <h4 class="font-medium-1 mb-0">{{council.council}}</h4>
                        </div>
                    </div>
                </div>
            </div>
            <!--Reports-->
            <div class="card-header d-flex justify-content-between">
                <h4 class="card-title mb-0">Reportes</h4>
                <button type="button" class="btn btn-success" ngbTooltip="Agregar Reporte" (click)="createReport()">
                    <span class="material-icons">
                        add
                    </span>
                </button>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="media pt-0 pb-2" *ngFor="let report of reports">
                        <div class="mr-3 avatar rounded">
                            <span class="badge bg-light-danger">
                                {{report.frecuence}}
                            </span>
                        </div>
                        <div class="media-body">
                            <h4 class="font-medium-1 mb-0">{{report.report}}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>